/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:08:10
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsyMultiTextEditor from '../../BsyMultiTextEditor';

import BsySelect from '../../BsySelect';
import BsySelectCheckBox from '../../BsySelectCheckBox';
import BsySelectList from '../../BsySelectList';
import BsySelectListCheckBox from '../../BsySelectListCheckBox';
import BsyTextEditor from '../../BsyTextEditor';
import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterText extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            valueMode: BsyConfig().CONST.FILTER_VALUE_MODE.ITEM,
            customItem: {
                text: React.language("unfilled"),
                value: "hasEmpty"
            },
            ...props
        })
        // console.log("props", props);
        this.dashText = null;
    }



    doFilterRely = (t, rel, widgetFilter) => {
        var i = BsyConfig().CONST.FILTER_VALUE_MODE;
        this.filterRely = t;
        this.rel = rel;

        if (this.valueMode === i.ITEM)
            switch (this.method) {
                case BsyConfig().CONST.FILTER_METHOD.EQ:
                case BsyConfig().CONST.FILTER_METHOD.NE:
                case BsyConfig().CONST.FILTER_METHOD.IN:
                case BsyConfig().CONST.FILTER_METHOD.NIN:
                    this.dashText && this.dashText.doFilterRely && this.dashText.doFilterRely(t, rel, widgetFilter)
                    break
                default: break
            }
    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.EQ,
        BsyConfig().CONST.FILTER_METHOD.NE,
        BsyConfig().CONST.FILTER_METHOD.IN,
        BsyConfig().CONST.FILTER_METHOD.NIN,
        BsyConfig().CONST.FILTER_METHOD.LK,
        BsyConfig().CONST.FILTER_METHOD.ULK,
        BsyConfig().CONST.FILTER_METHOD.EP,
        BsyConfig().CONST.FILTER_METHOD.NEP]
    }


    getValue = () => {
        let t = this.options;
        if (this.dashText) {
            let e = this.dashText.getValue()
                , i = BsyConfig().CONST.FILTER_VALUE_MODE;
            switch (this.valueMode) {
                case i.ITEM:
                    switch (this.method) {
                        case BsyConfig().CONST.FILTER_METHOD.EQ:
                        case BsyConfig().CONST.FILTER_METHOD.NE:
                        case BsyConfig().CONST.FILTER_METHOD.LK:
                        case BsyConfig().CONST.FILTER_METHOD.ULK:
                            return {
                                value: e
                            };
                        case BsyConfig().CONST.FILTER_METHOD.IN:
                        case BsyConfig().CONST.FILTER_METHOD.NIN:
                            if ("checklist" === this._getCompType()) {
                                let a = !1
                                    , n = [];
                                BsyUtils.forEach(e, function (e, i) {
                                    i !== t.customItem.value ? n.push(i) : a = !0
                                })
                                return {
                                    hasEmpty: a,
                                    items: n
                                }
                            }
                            if (BsyUtils.isObjectEmpty(e))
                                return { items: [], hasEmpty: false };
                            let e1 = [].concat(e)
                                , t = !1
                                , i = e.indexOf(BsyConfig().CONST.PARAMETER.EMPTY);
                            if (i > -1) {
                                t = !0
                                e1.splice(i, 1)
                            }
                            return {
                                hasEmpty: t,
                                items: e1
                            }
                        // return e;
                        default:
                            return null
                    }

                case i.CUSTOM:
                    switch (this.method) {
                        case BsyConfig().CONST.FILTER_METHOD.EQ:
                        case BsyConfig().CONST.FILTER_METHOD.NE:
                        case BsyConfig().CONST.FILTER_METHOD.LK:
                        case BsyConfig().CONST.FILTER_METHOD.ULK:
                            return {
                                value: e
                            };
                        case BsyConfig().CONST.FILTER_METHOD.IN:
                        case BsyConfig().CONST.FILTER_METHOD.NIN:
                            return {
                                items: e
                            };
                        default:
                            return null
                    }

                case i.INPUT: {
                    let result = {
                        value: e,
                        likeMatch: this.likeMatch ? this.likeMatch.getValue() : t.defaultConfig.likeMatch,
                    };
                    return result;
                }
                default:
            }
        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
        if (this.filterRely) {
            this.doFilterRely(this.filterRely, this.rel)
        }
    }

    renderCont = () => {
        let e = this
        let i = this.options;
        let a = BsyConfig().CONST.FILTER_VALUE_MODE;
        let c = this._getAsyncConfig()
        if (BsyUtils.isObjectEmpty(c)) {
            this.dashText = null;
            return <span className='error-tip'>{React.language("field.deleted.tip1")}</span>;
        }
        let val = this.getMiddleValue() || {};
        switch (e.valueMode) {
            case a.ITEM:
                switch (e.method) {
                    case BsyConfig().CONST.FILTER_METHOD.EQ:
                    case BsyConfig().CONST.FILTER_METHOD.NE:
                        if (i.height > i.minRow) {
                            return <BsySelectList
                                theme={this.props.theme}
                                hasLimit={!0}
                                asyncResultKey={i.asyncResultKey || "items"}
                                allowBlank={true}
                                designAppId={i.designAppId}
                                designEntryId={i.designEntryId}
                                subformName={i.designSubform}
                                orgWidgetName={i.designWidgetName}
                                onBeforeAsync={i.onBeforeAsync}
                                value={val ? val.value : null}
                                onStopEdit={e1 => {
                                    e.value = e.getValue()
                                    BsyUtils.applyFunc(e, i.onStopEdit, [{
                                        value: e.getValue(),
                                        valueMode: e.valueMode,
                                        method: e.method,
                                    }, i], !1)
                                }}
                                getContext={this.getContext}
                                async={c}
                            ></BsySelectList>
                        } else {
                            return <BsySelect
                                theme={this.props.theme}
                                hasLimit={!0}
                                designAppId={i.designAppId}
                                designEntryId={i.designEntryId}
                                subformName={i.designSubform}
                                orgWidgetName={i.designWidgetName}
                                onBeforeAsync={i.onBeforeAsync}
                                asyncResultKey={i.asyncResultKey || "items"}
                                allowBlank={true}
                                height={34}
                                value={val ? val.value : null}
                                onStopEdit={e1 => {
                                    e.value = e.getValue()
                                    BsyUtils.applyFunc(e, i.onStopEdit, [{
                                        value: e.getValue(),
                                        valueMode: e.valueMode,
                                        method: e.method,
                                    }, i], !1)
                                }}
                                getContext={this.getContext}
                                async={c}
                            />
                        }


                    case BsyConfig().CONST.FILTER_METHOD.IN:
                    case BsyConfig().CONST.FILTER_METHOD.NIN:
                        // this._createComboCheck();
                        let vals = [];
                        if (val.hasEmpty) {
                            vals.push(BsyConfig().CONST.PARAMETER.EMPTY)
                        }
                        if (val.items)
                            vals = vals.concat(val.items);
                        if (i.height > i.minRow) {
                            return <BsySelectListCheckBox
                                theme={this.props.theme}
                                designAppId={i.designAppId}
                                designEntryId={i.designEntryId}
                                subformName={i.designSubform}
                                orgWidgetName={i.designWidgetName}
                                getContext={this.getContext}
                                asyncResultKey={i.asyncResultKey || "items"}
                                hasLimit={!0}
                                onBeforeAsync={i.onBeforeAsync}
                                value={vals}
                                onStopEdit={e1 => {
                                    e.value = e.getValue()
                                    BsyUtils.applyFunc(e, i.onStopEdit, [{
                                        value: e.getValue(),
                                        valueMode: e.valueMode,
                                        method: e.method,
                                    }, i], !1)
                                }}
                                async={c}
                            />
                        } else {
                            return <BsySelectCheckBox
                                theme={this.props.theme}
                                getContext={this.getContext}
                                // hasDefault={!0}
                                designAppId={i.designAppId}
                                designEntryId={i.designEntryId}
                                subformName={i.designSubform}
                                orgWidgetName={i.designWidgetName}
                                asyncResultKey={i.asyncResultKey || "items"}
                                hasLimit={!0}
                                value={vals}
                                height={34}
                                onBeforeAsync={i.onBeforeAsync}
                                hasSelectAll={true}
                                hasSelectEmpty={true}
                                onStopEdit={e1 => {
                                    e.value = e.getValue()
                                    BsyUtils.applyFunc(e, i.onStopEdit, [{
                                        value: e.getValue(),
                                        valueMode: e.valueMode,
                                        method: e.method,
                                    }, i], !1)
                                }}
                                async={c}
                            />
                        }


                    case BsyConfig().CONST.FILTER_METHOD.LK:
                    case BsyConfig().CONST.FILTER_METHOD.ULK:

                        return <BsyTextEditor
                            getContext={this.getContext}
                            asyncResultKey={i.asyncResultKey || "items"}
                            width={"100%"}
                            height={34}
                            value={val ? val.value : null}
                            onStopEdit={(t) => {
                                e.value = e.getValue()
                                BsyUtils.applyFunc(this, this.props.onStopEdit, [{
                                    value: e.getValue(),
                                    method: e.method,
                                    valueMode: e.valueMode
                                }, i], !1)
                            }}
                        ></BsyTextEditor>


                    default:
                        return '';
                }

            case a.CUSTOM:
                switch (e.method) {
                    case BsyConfig().CONST.FILTER_METHOD.EQ:
                    case BsyConfig().CONST.FILTER_METHOD.NE:
                    case BsyConfig().CONST.FILTER_METHOD.LK:
                    case BsyConfig().CONST.FILTER_METHOD.ULK:

                        return <BsyTextEditor
                            getContext={this.getContext}
                            asyncResultKey={i.asyncResultKey || "items"}
                            width={"100%"}
                            height={34}
                            value={val ? val.value : null}
                            onStopEdit={(t) => {
                                e.value = e.getValue()
                                BsyUtils.applyFunc(this, this.props.onStopEdit, [{
                                    value: e.getValue(),
                                    method: e.method,
                                    valueMode: e.valueMode
                                }, i], !1)
                            }}
                        ></BsyTextEditor>

                    case BsyConfig().CONST.FILTER_METHOD.IN:
                    case BsyConfig().CONST.FILTER_METHOD.NIN:
                        return <BsyMultiTextEditor
                            getContext={this.getContext}
                            asyncResultKey={i.asyncResultKey || "items"}
                            width={"100%"}
                            height={34}
                            value={val.items ? val.items : []}
                            autoWrap={i.height > i.minRow}
                            onStopEdit={(t) => {
                                e.value = e.getValue();
                                BsyUtils.applyFunc(this, this.props.onStopEdit, [{
                                    value: e.getValue(),
                                    method: e.method,
                                    valueMode: e.valueMode
                                }, i], !1)
                            }}
                        >

                        </BsyMultiTextEditor>
                    //     this.dashText = new BsyConfig().MultiTextEditor({
                    //         renderEl: t("<div />").appendTo(this.$content),
                    //         width: "100%",
                    //         autoWrap: i.sizeY > i.minRow,
                    //         height: i.sizeY > i.minRow ? this.getDashContentHeight() : 32,
                    //         onStopEdit: function() {
                    //             BsyConfig().Utils.applyFunc(e, i.onStopEdit, [], !1)
                    //         }
                    //     });

                    default:
                    // this.$content.remove(),
                    // this.$content = null
                }
                break;
            case a.INPUT: {

                return <BsyTextEditor
                    getContext={this.getContext}
                    asyncResultKey={i.asyncResultKey || "items"}
                    width={"100%"}
                    height={34}
                    value={val ? val.value : null}
                    onStopEdit={(t) => {
                        e.value = e.getValue()
                        BsyUtils.applyFunc(this, this.props.onStopEdit, [{
                            value: e.getValue(),
                            method: e.method,
                            valueMode: e.valueMode
                        }, i], !1)
                    }}
                ></BsyTextEditor>


            }
            default:
        }
    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }
}

